import { Component, computed, inject, input, output } from '@angular/core';
import { DateUtils } from '@shared/utils/date/date.utils';
import { CheckKeys } from '@config/keys/check.keys';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-resume-check-atom',
  templateUrl: './resume-check-atom.component.html',
  standalone: false,
})
export class ResumeCheckAtomComponent {
  private readonly translateService = inject(TranslateService);

  readonly title = input<string>();
  readonly shopName = input.required<string>();
  readonly tableNumber = input('');
  readonly checkNumber = input('');
  readonly checkId = input('');
  readonly checkAmount = input.required<number>();
  readonly checkDate = input.required<string>();
  readonly checkOutsandingAmount = input.required<number>();
  readonly nbItems = input.required<number>();

  readonly cardClick = output<void>();

  readonly checkKeys = CheckKeys;

  readonly formattedCheckDate = computed(() =>
    DateUtils.dayjsInMarketplaceTimezone(this.checkDate()).format(
      this.translateService.instant('date.short-with-time-format'),
    ),
  );
}
